import React, { useState, useEffect } from 'react';
import { useAuth, API_URL, Currency } from '../contexts/AuthContext';
import { Banknote, Clock } from 'lucide-react';

export default function Caixa() {
  const { token } = useAuth();
  const [session, setSession] = useState<any>(null);
  const [movements, setMovements] = useState<any[]>([]);
  const [form, setForm] = useState({ opening_balance: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/cash/session/current`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(s => { setSession(s); if (s?.id) fetchMovements(s.id); })
      .catch(() => {});
  }, [token]);

  const fetchMovements = (id: string) => {
    fetch(`${API_URL}/cash/movements?session_id=${id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => setMovements(d)).catch(() => {});
  };

  const openSession = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/cash/session/open`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ opening_balance: parseFloat(form.opening_balance) || 0 }),
      });
      if (!r.ok) { setMsg('Erro ao abrir caixa'); return; }
      const j = await r.json();
      setSession(j);
      fetchMovements(j.id);
    } catch { setMsg('Erro interno'); }
  };

  const closeSession = async () => {
    if (!session) return;
    const count = window.prompt('Valor contado no caixa (dinheiro):', '');
    if (count === null) return;
    try {
      const r = await fetch(`${API_URL}/cash/session/close`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ cash_session_id: session.id, cash_count: parseFloat(count) || 0 }),
      });
      const j = await r.json();
      if (!r.ok) { setMsg(j.error || 'Erro ao fechar'); return; }
      setMsg('Caixa fechado. Diferença: ' + Currency(j.difference));
      setSession(null);
      setMovements([]);
    } catch { setMsg('Erro interno'); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Controle de Caixa</h1>
        <p className="text-gray-600">Abertura, fechamento e movimentações de caixa</p>
      </div>
      {msg && <div className="rounded-lg p-3 text-sm bg-green-50 border border-green-200 text-green-700">{msg}</div>}
      {!session ? (
        <div className="card">
          <h2 className="text-sm font-semibold text-gray-700 mb-3">Abrir caixa</h2>
          <p className="text-sm text-gray-600 mb-3">Não há caixa aberto. Informe o saldo inicial.</p>
          <form onSubmit={openSession} className="space-y-3">
            <div><label className="text-xs font-medium text-gray-500 block mb-1">Saldo inicial (R$)</label><input className="input" type="number" step="0.01" value={form.opening_balance} onChange={e => setForm({ ...form, opening_balance: e.target.value })} required /></div>
            <button className="btn-success w-full">Abrir caixa</button>
          </form>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="card"><div className="text-xs text-gray-500 uppercase">Saldo inicial</div><div className="text-2xl font-bold">{Currency(session.opening_balance)}</div></div>
            <div className="card"><div className="text-xs text-gray-500 uppercase">Movimentações</div><div className="text-2xl font-bold">{movements.length}</div></div>
            <div className="card"><div className="text-xs text-gray-500 uppercase">Status</div><div className="badge badge-ok">Aberto</div></div>
          </div>
          <div className="card">
            <h2 className="text-sm font-semibold text-gray-700 mb-3"><Clock size={16} className="mr-2" /> Movimentações</h2>
            <div className="space-y-2">
              {movements.map(m => (
                <div key={m.id} className="flex items-center justify-between py-2 text-sm border-b border-gray-100 last:border-0">
                  <div className="flex items-center gap-2">
                    <span className={`badge ${m.type === 'in' ? 'badge-ok' : 'badge-danger'}`}>{m.type === 'in' ? 'Entrada' : 'Saída'}</span>
                    <span className="text-gray-600">{m.description}</span>
                  </div>
                  <div className="text-right font-medium">{m.type === 'in' ? '+' : '-'}{Currency(m.amount)}</div>
                </div>
              ))}
              {movements.length === 0 && <p className="text-xs text-gray-500 text-center py-4">Sem movimentações</p>}
            </div>
          </div>
          <div className="pt-4"><button onClick={closeSession} className="btn-danger w-full">Fechar caixa</button></div>
        </div>
      )}
    </div>
  );
}
